import './franchise.scss';
import { setupLayout } from '../Shared/layout';
import { setupEnquiryForm, EnquiryFormType } from '../Shared/Component/EnquiryForm/enquiry-form';
import { appConfig } from '../../src/appConfig';
import { setupGoogleMap } from '../../src/module/google-map';

setupLayout();

setupGoogleMap({
    apiKey: appConfig.googleMapApiKey,
    languageIsoCode: (document.getElementById('inputHiddenForPageLanguageIsoCode') as HTMLInputElement).value,
    styles: appConfig.googleMapStyles
});

setupEnquiryForm(EnquiryFormType.Franchise);